// **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "insert",
        regionType:  "region_name_currency_symbol",
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "no",
        selectorFlagMap: {'en': 'en-US', 'de': 'de'},
        displayType: "language_code",
        fontColor: "#000000",
        backgroundColor: "#FFFFFF",
        backgroundOpacity: "1.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",
        defaultRegion: "US",
        primaryRegionById: {},
        availableRegionsByCode: {},
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "United States", "code": "US", "currency": {"code": "USD", "symbol": "$"}, "languages": {"English": {"name": "English", "native_name": "English", "code": "en", "default": true}, "Deutsch": {"name": "Deutsch (German)", "native_name": "Deutsch", "code": "de", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
        